const actionScope = '[Professional Services Recent Sessions]';

export class LoadRecentSessions {
  static readonly type = `${actionScope} Load Recent Sessions`;
}
